import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppMHModule } from './app/app.module';
import { LoggerService } from 'projects/shared/lib/services/infrastructure/logger/logger.service';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';

if (ENVIRONMENT.production) {
  enableProdMode();
  let metaTag = document.createElement('meta');
  metaTag.name = 'robots';
  metaTag.content = 'index, follow';
  document.head.appendChild(metaTag);
} else {
  let metaTag = document.createElement('meta');
  metaTag.name = 'robots';
  metaTag.content = 'noindex';
  document.head.appendChild(metaTag);
}

platformBrowserDynamic().bootstrapModule(AppMHModule)
  .catch(err => LoggerService.fatal(err, "Main"));
